import fetch from "isomorphic-fetch";
import { useHistory } from "react-router-dom";
import { API } from "../config";
//notifications
import { getCookie, userSessionExpired } from "./auth";
const Organizations = () => {
  const history = useHistory();
  const updateOrganization = (organization, Id) => {
    return fetch(`${API}/organizations/${Id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(organization),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const addOrganization = (data) => {
    return fetch(`${API}/organizations`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const deleteOrganization = (catagoryId) => {
    return fetch(`${API}/organizations/${catagoryId}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const unlinkOrganization = (id, adminId) => {
    return fetch(`${API}/organizations/unlink/${id}/${adminId}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewOrganizations = (id) => {
    return fetch(`${API}/organizations`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };

  const viewAllOrganization = (id) => {
    return fetch(`${API}/organizations/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewAllActivity = (
    page,
    limit,
    searchQuery,
    startDate,
    endDate,
    staffName
  ) => {
    return fetch(
      `${API}/organizations/activity/?page=${page}&limit=${limit}&search=${searchQuery}&startDate=${startDate}&endDate=${endDate}&staffName=${staffName}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("token")}`,
        },
      }
    )
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewAllStaffs = () => {
    return fetch(`${API}/organizations/staffs`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };

  return {
    deleteOrganization,
    viewAllOrganization,
    updateOrganization,
    viewAllActivity,
    viewAllStaffs,
    viewOrganizations,
    addOrganization,
    unlinkOrganization,
  };
};

export default Organizations;
